import script from "./ImportF1User.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportF1User.vue?vue&type=script&setup=true&lang=js"

import "./ImportF1User.vue?vue&type=style&index=0&id=4f198d2e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f198d2e"]])

export default __exports__